module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms16x"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms16xIndex,
      "columnEvent": _vm.columnEvent,
      "csvExportDisp": true,
      "searchBoxAlias": "hrms16x",
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d11260a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms16x/component.vue
// module id = 3654
// module chunks = 1